<!--
  --
  -- クーポン入力シート
  --
  -->
<template>
  <v-sheet>
    <c-book-subheader>クーポン</c-book-subheader>

    <v-sheet class="pa-2 mb-4" color="secondary" rounded>
      <c-description class="text-caption">
        <p>
          利用可能なクーポンがある場合、クーポンコードを入力頂くと特典を受けることができます。
        </p>
        <p>
          クーポンコードは大文字小文字に注意し、半角で入力ください。<br>
          右側の <kbd>入力</kbd> ボタンをクリックすることで確定します。
        </p>
      </c-description>
    </v-sheet>

    <c-coupon-field :value="value" @change="$emit('change', $event)"/>

    <v-sheet
      v-if="value"
      rounded
      class="text-caption px-2 py-1 success--text"
      style="border: thin solid;"
    >
      <span v-if="value.name">{{value.name}} ({{value.value | comma}} 円引き) を適用します。</span><br>
      <span v-if="value.note">{{value.note}}</span>
    </v-sheet>
  </v-sheet>
</template>

<script>
import CBookSubheader from '@/pages/book/components/CBookSubheader'
import CDescription from '@/components/CDescription'
import CCouponField from './CCouponField'

export default {
  name: 'CCouponSheet',
  components: {
    CBookSubheader,
    CDescription,
    CCouponField
  },

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  }
}
</script>
